import React, { useState } from "react";
import { Box, Drawer, IconButton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Menu as MenuIcon } from "@mui/icons-material";
import ConversationSidebar from "./ConversationSidebar";
import ChatWindow from "./ChatWindow";
import "../../styles/assistant-v2.css";

const AssistantLayout = ({
  conversations,
  currentConversationId,
  messages,
  loading,
  error,
  onNewChat,
  onSelectConversation,
  onDeleteConversation,
  onDeleteAll,
  onRenameConversation,
  onSendMessage,
  onRetry,
  onCopy,
  onRegenerate,
  onFeedback,
  onToggleSources,
  onStopGeneration,
  onClearConversation,
  suggestedQuestions,
  onSelectSuggestedQuestion,
  loadingHistory,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [showSources, setShowSources] = useState(false);

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleToggleSources = () => {
    setShowSources(!showSources);
    if (onToggleSources) {
      onToggleSources(!showSources);
    }
  };

  const sidebarContent = (
    <ConversationSidebar
      conversations={conversations}
      currentConversationId={currentConversationId}
      onSelectConversation={(id) => {
        onSelectConversation(id);
        if (isMobile) setMobileSidebarOpen(false);
      }}
      onNewChat={() => {
        onNewChat();
        if (isMobile) setMobileSidebarOpen(false);
      }}
      onDeleteConversation={onDeleteConversation}
      onDeleteAll={onDeleteAll}
      onRenameConversation={onRenameConversation}
      loading={loadingHistory}
    />
  );

  return (
    <Box className="assistant-page" sx={{ display: 'flex', width: '100%', height: 'calc(100vh - 64px)', minHeight: 0, overflow: 'hidden' }}>

      {/* Conversations Sidebar (280-310px on desktop, drawer on mobile) */}
      {!isMobile && (
        <Box className="assistant-conversations" sx={{ width: '295px', minWidth: '280px', maxWidth: '310px', flexShrink: 0, borderRight: '1px solid #e5e7eb', bgcolor: '#fff', display: 'flex', flexDirection: 'column' }}>
          {sidebarContent}
        </Box>
      )}

      {/* Mobile Drawer for Conversations Sidebar */}
      {isMobile && (
        <Drawer
          anchor="left"
          open={mobileSidebarOpen}
          onClose={toggleMobileSidebar}
          sx={{ '& .MuiDrawer-paper': { width: 300, boxSizing: 'border-box' } }}
        >
          {sidebarContent}
        </Drawer>
      )}

      {/* Chat Area - takes remaining space */}
      <Box className="assistant-chat" sx={{ flex: 1, minWidth: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {isMobile && (
          <Box sx={{ position: 'absolute', top: 12, left: 12, zIndex: 10 }}>
            <IconButton onClick={toggleMobileSidebar} sx={{ bgcolor: 'background.paper', boxShadow: 1 }}>
              <MenuIcon />
            </IconButton>
          </Box>
        )}
        
        <ChatWindow
          messages={messages}
          loading={loading}
          error={error}
          onSendMessage={onSendMessage}
          onRetry={onRetry}
          onCopy={onCopy}
          onRegenerate={onRegenerate}
          onFeedback={onFeedback}
          onToggleSources={handleToggleSources}
          showSources={showSources}
          onStopGeneration={onStopGeneration}
          onNewChat={onNewChat}
          onClearConversation={onClearConversation}
          suggestedQuestions={suggestedQuestions}
          onSelectSuggestedQuestion={onSelectSuggestedQuestion}
        />
      </Box>
    </Box>
  );
};

export default AssistantLayout;
